import _ from 'lodash'
import React from 'react'

import { Box, BoxProps } from '../Box'
import { CenterChildren } from '../Center'
import { Spin } from '../Spin'
import { Title, Text, TitleProps } from '../Text'
import { TextProps } from '../Text/Text'

export type InfoBoxProps = {
  label: string
  value: React.ReactText | React.ReactText[]
  boxProps?: BoxProps
  valueProps?: TextProps
  titleProps?: TitleProps
  loading?: boolean
  displayValues?: boolean
  maxItems?: number
}

export const InfoBox = ({
  label,
  value,
  boxProps,
  titleProps,
  valueProps,
  loading,
  displayValues = true,
  maxItems
}: InfoBoxProps) => {
  return (
    <Box width={[0.5, 0.5, 0.25]} px={[1, 2]} pb={2} {...boxProps}>
      <Title level="small" padding={{ bottom: '20px' }} bold {...titleProps}>
        {label}
      </Title>
      {!loading &&
        _.map(_.isArray(value) ? (maxItems ? _.take(value, maxItems) : value) : [value], value => (
          <Text
            key={label}
            fontSize="14px"
            display={displayValues ? 'inherit' : 'none'}
            {...valueProps}
            dangerouslySetInnerHTML={{ __html: _.isNumber(value) ? `${value}` : value }}
          />
        ))}
      {loading && (
        <CenterChildren>
          <Spin delay={250} />
        </CenterChildren>
      )}
    </Box>
  )
}
